import { Assessment, Business, CheckCircle, Group, TrendingUp } from '@mui/icons-material';
import { Box, Card, CardContent, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React from 'react';

const ServicesScreen: React.FC = () => {
    const services = [
        {
            icon: <TrendingUp sx={{ fontSize: 48 }} />,
            title: 'Strategy Consulting',
            description: 'Develop winning strategies that position your business for sustainable growth and competitive advantage.',
            features: ['Market Analysis', 'Competitive Intelligence', 'Strategic Planning', 'Growth Strategies']
        },
        {
            icon: <Assessment sx={{ fontSize: 48 }} />,
            title: 'Digital Transformation',
            description: 'Navigate the digital landscape with confidence through our comprehensive transformation programs.',
            features: ['Technology Assessment', 'Digital Strategy', 'Process Automation', 'Change Management']
        },
        {
            icon: <Group sx={{ fontSize: 48 }} />,
            title: 'Operations Excellence',
            description: 'Optimize your operations to achieve peak efficiency and deliver exceptional customer value.',
            features: ['Process Optimization', 'Quality Management', 'Supply Chain', 'Performance Metrics']
        },
        {
            icon: <Business sx={{ fontSize: 48 }} />,
            title: 'Change Management',
            description: 'Lead successful organizational change with our proven methodologies and expert guidance.',
            features: ['Change Strategy', 'Stakeholder Engagement', 'Training Programs', 'Culture Transformation']
        },
    ];

    return (
        <Container maxWidth="lg" sx={{ py: 8 }}>
            <Typography
                variant="h2"
                component="h1"
                textAlign="center"
                gutterBottom
                sx={{ fontWeight: 'bold', mb: 2 }}
            >
                Our Services
            </Typography>
            <Typography
                variant="h6"
                textAlign="center"
                sx={{ mb: 8, color: 'text.secondary', maxWidth: '600px', mx: 'auto' }}
            >
                Comprehensive consulting solutions tailored to your business needs
            </Typography>

            <Grid container spacing={4}>
                {services.map((service, index) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={index}>
                        <Card
                            sx={{
                                height: '100%',
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: 8,
                                },
                            }}
                        >
                            <CardContent sx={{ p: 4 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                    <Box sx={{ color: '#1565c0', mr: 2 }}>
                                        {service.icon}
                                    </Box>
                                    <Typography variant="h4" component="h3" sx={{ fontWeight: 'bold' }}>
                                        {service.title}
                                    </Typography>
                                </Box>
                                <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
                                    {service.description}
                                </Typography>
                                <List dense>
                                    {service.features.map((feature, idx) => (
                                        <ListItem key={idx} sx={{ pl: 0 }}>
                                            <ListItemIcon sx={{ minWidth: 36 }}>
                                                <CheckCircle sx={{ color: '#1565c0', fontSize: 20 }} />
                                            </ListItemIcon>
                                            <ListItemText primary={feature} />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default ServicesScreen;